'use strict';

const setSelectedTheme = (state, themeName) => {
  state.selectedThemeName = themeName;
};

export default {
  setSelectedTheme
};
